// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__yv+x+","img":"Gallery_img__OHxd9","video":"Gallery_video__qB0TV"};